import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import UploadButton from "./UploadButton";
import PreviewBox from "./PreviewBox";
import CustomButton from "../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../media/images/icons/arrow-left-circle";

export default function UploadDocuments() {
  const [docs, setDocs] = useState([
    {
      title: "بارگذاری کارت ملی(صفحه رو)",
      filePath: "",
    },
    {
      title: "بارگذاری کارت ملی(صفحه پشت)",
      filePath: "",
    },
    {
      title: "بارگذاری کارت هوشمند راننده",
      filePath: "",
    },
    {
      title: "بارگذاری گواهینامه راننده",
      filePath: "",
    },
  ]);

  const handleUploadFile = (file: File, index: number) => {
    setDocs((prev) =>
      prev.map((item, docIndex) => {
        if (docIndex === index) {
          return {
            ...item,
            filePath: URL.createObjectURL(file),
          };
        } else {
          return item;
        }
      })
    );
    console.log(docs);
  };

  const handleDeleteFile = (index: number) => {
    setDocs((prev) =>
      prev.map((item, docIndex) => {
        if (docIndex === index) {
          return {
            ...item,
            filePath: "",
          };
        } else {
          return item;
        }
      })
    );
  };

  const theme = useTheme();
  return (
    <Box
      sx={{
        marginTop: "16px",
        width: "100%",
        backgroundColor: "background.default",
        padding: "16px",
        borderRadius: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "secondary.dark",
          fontSize: "16px",
        }}
      >
        ثبت مشخصات ناوگان
      </Typography>
      <Box
        sx={{
          marginTop: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {docs.map((item, index) => (
          <UploadButton
            index={index}
            handleUploadFile={handleUploadFile}
            title={item.title}
            filePath={item.filePath}
          />
        ))}

        {docs.find((item) => item.filePath !== "") && (
          <PreviewBox handleDeleteFile={handleDeleteFile} docs={docs} />
        )}

        <CustomButton
          // loading={loading}
          // onClick={formik.handleSubmit}
          flexDirection="row"
          title="تکمیل مرحله و ادامه"
          justifyContent="center"
          bgColor="secondary.main"
          width="100%"
          fSize="16px"
          px="10px"
          py="10px"
          borderRadius="10px"
          icon2={<ArrowLeftCircle size={32} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
